import React from 'react'
import Hero from '../components/Hero';
import Prints from '../components/Prints';
import Apparels from '../components/Apparels';
import Platform from '../components/Platform';
import Footer from '../components/Footer';


const Home = () => {
  return (
    <>
      <Hero />
      <Prints />
      <Apparels />
      <Platform />
      <Footer />
    </>
  )
}

export default Home